import { LOAD_STATE } from '../../../shared/axios/axios.constants';
import {
    editCampaign,
    editValueBasedOnField,
    formatFieldValueToApi,
    formatBidStrategyForCampaigns,
    updateTagGroupByCluster,
} from './campaigns.utils';
import {
    showToast,
    TOAST_TYPE,
} from '../../../shared/components/messages-and-errors/ToastsNotifications';
import {
    getCampaignsReportsConfig,
    getEditCampaignsReportsConfig,
} from '../../campaigns/campaigns.api';
import { handleApiError } from '../../../shared/utils/errors';

export const GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED = '@dashboard/campaigns/GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED';
export const GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED = '@dashboard/campaigns/GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED';
export const GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED = '@dashboard/campaigns/GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_FAILED';
export const GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED = '@dashboard/campaigns/GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED';
export const EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_CALLED = '@dashboard/campaigns/EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_CALLED';
export const EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_SUCCEEDED = '@dashboard/campaigns/EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_SUCCEEDED';
export const EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_FAILED = '@dashboard/campaigns/EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_FAILED';
export const UPDATE_CAMPAIGNS = '@dashboard/campaigns/UPDATE_CAMPAIGNS';
export const UPDATE_CAMPAIGNS_ITEMS = '@dashboard/campaigns/UPDATE_CAMPAIGNS_ITEMS';
export const UPDATE_CAMPAIGNS_TAG_NAME = '@campaigns/UPDATE_CAMPAIGNS_TAG_NAME';

const callWarning = (action) => {
    if (action && action.type === EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_FAILED) {
        showToast(
            handleApiError(action.payload.response.data.errors || action.payload.response.data),
            TOAST_TYPE.ERROR,
            { autoClose: 10000 },
        );
    }
    if (action && action.type === EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_SUCCEEDED) {
        showToast(
            `Successfully changed ${action.requestAction.payload.field}`,
            TOAST_TYPE.SUCCESS,
        );
    }
};

// TODO: essa função será removida quando o PR abaixo for mergeado:
// https://github.com/paretogroup/platform-spa/pull/1812
// É necessário mantê-la por enquanto, pois precisamos temporariamente do
// preenchimento desse domínio até sua total remoção.
export const getCampaignsReportsStatsDeprecated = ({
    customerType,
    customerId,
    startDate,
    endDate,
    isNewOverview,
    conversionType,
}) => ({
    type: GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED,
    actionTypes: {
        success: GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED,
        fail: GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED,
        canceled: GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED,
    },
    config: getCampaignsReportsConfig({
        customerType,
        customerId,
        startDate,
        endDate,
        isNewOverview,
        conversionType,
    }),
});

export const editCampaignReportsStats = ({
    accountId,
    platform,
    campaignId,
    subLevelId,
    field,
    fieldValue,
    originalValue,
    budgetId,
}) => ({
    type: EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_CALLED,
    actionTypes: {
        success: EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_SUCCEEDED,
        fail: EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_FAILED,
    },
    config: getEditCampaignsReportsConfig({
        accountId,
        platform,
        campaignId,
        subLevelId,
        field,
        fieldValue: formatFieldValueToApi(field, fieldValue, platform),
        budgetId,
    }),
    payload: {
        accountId,
        platform,
        campaignId,
        subLevelId,
        field,
        fieldValue,
        originalValue,
    },
    meta: {
        onAxiosFinally: callWarning,
    },
});

export const updateCampaignsReport = ({
    campaigns,
}) => ({
    type: UPDATE_CAMPAIGNS,
    campaigns,
});

export const updateCampaignsItems = ({
    campaigns,
}) => ({
    type: UPDATE_CAMPAIGNS_ITEMS,
    campaigns,
});

export const updateCampaignsTagName = ({
    tagGroupId,
    newTagName,
    previousTagName,
}) => ({
    type: UPDATE_CAMPAIGNS_TAG_NAME,
    payload: {
        tagGroupId,
        newTagName,
        previousTagName,
    },
});

const initialState = {
    loadState: 'loading',
    data: [],
    error: null,
};


export const findCampaignsInStateAndUpdate = (state, campaignsToBeUpdate) => {
    const filterFacebookCampaign = state.items.filter(campaign => (campaign.level));
    if (filterFacebookCampaign) return [...filterFacebookCampaign, ...campaignsToBeUpdate];
    return campaignsToBeUpdate;
};

// eslint-disable-next-line complexity
export const campaignsReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_CALLED:
        return {
            ...state,
            loadState: LOAD_STATE.LOADING,
            data: [],
            error: null,

        };
    case GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED:
        return {
            ...state,
            loadState: LOAD_STATE.SUCCESS,
            data: formatBidStrategyForCampaigns(action.payload.data),
            error: null,

        };
    case GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED:
        return {
            ...state,
            loadState: LOAD_STATE.FAIL,
            data: [],
            error: action.payload,

        };
    case GET_CAMPAIGNS_CUSTOMERS_ID_REQUEST_CANCELED:
        return {
            ...state,
            loadState: LOAD_STATE.LOADING,
            data: [],
            error: action.payload,

        };
    case EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_CALLED:
        return {
            ...state,
            data: {
                ...state.data,
                items: editCampaign(
                    state.data,
                    action.payload.campaignId,
                    action.payload.subLevelId,
                    action.payload.field,
                    action.payload.fieldValue,
                    true,
                ),
            },
            error: null,
        };
    case EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_SUCCEEDED:
        return {
            ...state,
            data: {
                ...state.data,
                items: editCampaign(
                    state.data,
                    action.requestAction.payload.campaignId,
                    action.requestAction.payload.subLevelId,
                    action.requestAction.payload.field,
                    action.requestAction.payload.fieldValue,
                    false,
                ),
            },
            error: null,
        };
    case EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_FAILED:
        return {
            ...state,
            data: {
                ...state.data,
                items: editCampaign(
                    state.data,
                    action.requestAction.payload.campaignId,
                    action.requestAction.payload.subLevelId,
                    action.requestAction.payload.field,
                    editValueBasedOnField(
                        action.requestAction.payload.field,
                        action.requestAction.payload.originalValue,
                    ),
                    false,
                ),
            },
            error: action.payload,
            warning: action.requestAction.payload.field,
        };
    case UPDATE_CAMPAIGNS:
        return {
            ...state,
            error: null,
            data: {
                ...state.data,
                items: findCampaignsInStateAndUpdate(state.data, action.campaigns),
            },
        };
    case UPDATE_CAMPAIGNS_ITEMS:
        return {
            ...state,
            error: null,
            data: {
                ...state.data,
                items: action.campaigns,
            },
        };
    case UPDATE_CAMPAIGNS_TAG_NAME:
        return ({
            ...state,
            error: null,
            data: {
                ...state.data,
                items: updateTagGroupByCluster(
                    state.data.items,
                    action.payload,
                ),
            },
        });
    default:
        return state;
    }
};
